<woa-field [label]="label()" [link]="link()" [message]="message()" [translationParams]="translationParams()"
           [readOnly]="readOnly()" [disabled]="disabled()" [defaultInput]="input" (onActivateLink)="onActivateLink.emit()">
    <div class="text-field">
        <input #input class="text-field-input" [attr.id]="inputId()"
               [value]="displayValue()" (input)="handleInputEvent($event)"
               [attr.type]="type()" [attr.inputmode]="inputMode()" [attr.autocomplete]="autocomplete()"
               [attr.maxlength]="maxlength()" [attr.spellcheck]="spellcheck()" [readOnly]="readOnly()"
               [attr.aria-labelledby]="labelId()" [attr.aria-describedby]="describedBy()" [attr.aria-invalid]="ariaInvalid()">
        @if (!valueSignal()) {
            <div class="text-field-placeholder">
                {{ placeholder() | translate: translationParams() }}
            </div>
        }
    </div>
</woa-field>
